module.exports = __webpack_public_path__ + "officialStatic/img/soft14.f6427ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft14.png
// module id = eLpu
// module chunks = 0